import React, {Component} from "react";
import BackToUpperLevel from "./BackToUpperLevel.js";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import {BASE_LINK} from "../actions/types";
// import Button from '@material-ui/core/Button';
import iconSuccess from "../images/icon_success@2x.png";

class ReserveResult extends Component {
  componentDidMount() {
    console.log(this.props.match.params.type);
  }

  backIndex() {
    this.props.history.push(BASE_LINK);
  }

  render() {
    console.log(this.props)
    const {type, code} = this.props.match.params;
    if (type === "success") {
      return (
        <React.Fragment>
          <BackToUpperLevel title="预约结果" history={this.props.history}/>
          <div className="result-contain">
            <div className="result-desc">
              <img src={iconSuccess} alt="iconSuccess" width={72}/>
              <div className="result-success">成功</div>
              <div className="result-sub-desc">您已经{code == 1 ? "提交申请，耐心等待审核结果" : "成功预约"}</div>
            </div>
          </div>
          <div className="result-button-contain">
            <div className="result-button" style={{background: "#259083"}} onClick={() => this.backIndex()}>
              返回首页
            </div>
          </div>
        </React.Fragment>
      );
    } else if (type === "canceled") {
      return (
        <React.Fragment>
          <div>
            <NavigateBefore style={{marginTop: 16, marginLeft: 14}} onClick={() => this.props.history.go(-1)}/>
          </div>
          <div className="result-contain" style={{paddingTop: 62}}>
            <div className="result-desc">
              <img src={iconSuccess} alt="iconSuccess" width={72}/>
              <div className="result-success">成功</div>
              <div className="result-sub-desc">你已经成功取消预约</div>
            </div>
          </div>
          <div className="result-button-contain">
            <div className="result-button" style={{background: "#259083"}} onClick={() => this.backIndex()}>
              返回首页
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default ReserveResult;
